// extracted by mini-css-extract-plugin
module.exports = {"withLeftMargin":"info-icon_withLeftMargin__7H6eP"};